import React from 'react'

import { AccountsPayableProvider } from 'templates/AccountsPayable/context'

import AccountsPayableActionModals from 'components/Modal/AccountsPayableActionModals'
import ModalDetailsExpenses from 'components/Modal/ModalDetailsExpenses'

interface AccountsPayableDetailProps {
  isOpen: boolean
  uuid: string
  onClose: () => void
}

// Abre o ModalDetailsExpenses fora da página de Operação (a partir da busca
// global). O ModalDetailsExpenses depende do AccountsPayableContext, então
// envolvemos com o Provider (que é autossuficiente — só estados locais).
const AccountsPayableDetail = ({
  isOpen,
  uuid,
  onClose
}: AccountsPayableDetailProps) => {
  if (!isOpen) return null

  return (
    <AccountsPayableProvider>
      <ModalDetailsExpenses
        isOpen={isOpen}
        uuid={uuid}
        handleClose={() => onClose()}
      />
      <AccountsPayableActionModals />
    </AccountsPayableProvider>
  )
}

export default AccountsPayableDetail
